import { useRecoilState } from "recoil";
import { productKeyAtom } from "src/atoms";

// Dsf제품탭 파악
export const useIsDspmProduct = () => {
  const [productKey, setProductName] = useRecoilState(productKeyAtom);
  // console.log(
  //   "ProductKeyList.includes(userInfo?.loginType)",
  //   ProductKeyList.includes(userInfo?.loginType),
  //   userInfo?.loginType
  // );
  // console.log("isDspProduct", productKey);

  return {
    isDspmProduct: productKey === "DSPM",
  };
};
